import { render, staticRenderFns } from "./ProductGradeDetails.vue?vue&type=template&id=a915ec70"
import script from "./ProductGradeDetails.vue?vue&type=script&lang=js"
export * from "./ProductGradeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports